<template>
  <span>
    <table
      v-for="(item, index) in itemDetail.targets"
      :key="item.id"
      border="0"
      cellspacing="10"
      style="width: 100%; border-left: 0"
    >
      <tr v-if="itemDetail.targets.length > 1">
        <td style="border-left: 0" colspan="5" class="text_center">
          资产信息{{index + 1}}
        </td>
      </tr>

      <tr>
        <td class="w_td font_w_bold">资产名称</td>
        <td class="td_val text_left">
          {{ item.name }}
        </td>
        <td class="w_td font_w_bold">资产编号</td>
        <td class="td_val text_left">
          {{ item.assetCode }}
        </td>
      </tr>

      <tr v-if="item.assetCategoryTopName">
        <td class=" font_w_bold">资产类型</td>
        <td class="td_val text_left" colspan="4">
          {{item.assetCategoryTopName}}
        </td>
      </tr>

      <tr>
        <td class="font_w_bold">资产现状</td>
        <td class="td_val text_left " colspan="4">
          {{ actualityKey[item.actuality] || item.actuality}}
        </td>

        <!-- <td class="w_td font_w_bold">资产权益</td>
        <td class="td_val  text_left">
          {{ equitiesKey[item.equities] }}
        </td> -->
      </tr>
      <tr>
        <td class="w_td font_w_bold"> {{ isHouse?'建筑面积':'数量/面积' }} </td>
        <td colspan="4" class="td_val text_left">
          {{ item.quantity }}{{ item.quantity? quantityUnitKey[item.quantityUnit]:'' }}
        </td>
      </tr>

      <!-- <tr>
        <td class="font_w_bold">资产评估</td>
        <td
          colspan="4"
          class="text_left"
        >
          {{ whether[item.evaluated] }}
        </td>
      </tr> -->

      <template v-if="item.evaluated === 1">
        <tr>
          <td class="font_w_bold">评估机构</td>
          <td class="td_val text_left" :title="item.evalOrgan">
            {{ item.evalOrgan }}
          </td>
          <td class="font_w_bold">评估时间</td>
          <td class="td_val text_left">
            {{ item.evalDate }}
          </td>
        </tr>

        <tr>
          <td class="font_w_bold">评估价值</td>
          <td class="td_val text_left">
            {{ item.evalValue }}{{ item.evalValue?'元':'' }}
          </td>
          <td class="font_w_bold">账面价值</td>
          <td class="td_val text_left" colspan="2">
            {{ item.bookValue }}{{ item.bookValue?'元':'' }}
          </td>
        </tr>
      </template>

      <tr v-if="isHouse">
        <td class="font_w_bold">房产证号</td>
        <td class="td_val text_left">
          {{ item.certificateSeq }}
        </td>
        <td class="font_w_bold">附属设施</td>
        <td class="td_val text_left" colspan="2">
          {{ item.affiliatedFacilities }}
        </td>
      </tr>

      <tr v-if="isHouse">
        <td class="font_w_bold">使用年限</td>
        <td class="td_val text_left">
          {{ item.durableYear }}{{ item.durableYear?'年':'' }}
        </td>
        <td class="font_w_bold">已用年限</td>
        <td class="td_val text_left" colspan="2">
          {{ item.useYear }}{{ item.useYear?'年':'' }}
        </td>
      </tr>

      <tr v-if="isHouse">
        <td class="font_w_bold">占地面积</td>
        <td class="td_val text_left" colspan="4">
          {{ item.floorSpace }}{{ item.floorSpace? quantityUnitKey[item.spaceUnit]:'' }}
        </td>
      </tr>

      <tr>
        <td class="font_w_bold">坐落</td>
        <td
          colspan="4"
          class="text_left"
        >
          {{ item.address }}
        </td>
      </tr>

      <template v-if="isHouse">
        <tr>
          <td class="w_td font_w_bold">东至</td>
          <td class="td_val text_left">
            {{ item.east }}
          </td>
          <td class="w_td font_w_bold">南至</td>
          <td
            class="td_val  text_left"
          >
            {{ item.south }}
          </td>
        </tr>

        <tr>
          <td class="w_td font_w_bold">西至</td>
          <td class="td_val text_left">
            {{ item.west }}
          </td>
          <td class="w_td font_w_bold">北至</td>
          <td
            class="td_val  text_left"
          >
            {{ item.north }}
          </td>
        </tr>
      </template>

      <!-- <tr>
        <td class="font_w_bold">目前用途</td>
        <td class="text_left" colspan="4">
          {{ item.purpose }}
        </td>
      </tr> -->

    </table>
  </span>
</template>

<script>
import { mapGetters } from 'vuex'
import { numberTranToCN } from '@/utils'
export default {

  props: {
    itemDetail: {
      type: Object,
      default: () => {}
    }
  },

  computed: {
    ...mapGetters(['whether', 'quantityUnitKey', 'equitiesKey','assetPurposeKey','actualityKey']),

    // 是否房屋类型（房屋、建筑物、商铺类型）
    isHouse() {
      return ['fangwu', 'jianzhuwu', 'shangpu'].includes(this.itemDetail.targets[0].type)
    },

    // 数字转中文
    numberTranToCN() {
      return function(num) {
        return numberTranToCN(num)
      }
    }
  }
}
</script>

<style scoped lang="scss">

table {
    //标准单元格宽度

    .w_td {
      min-width: 147px;
    }
    //最大单元格宽度
    .td_val {
      width: 390px;
    }
    //最大单元格宽度

    tr {

      td {

        box-sizing: border-box;
        padding: 20px;
        border-top: 1px solid #e6e6e6;
        border-right: 1px solid #e6e6e6;
        word-break: break-word;

      }
    }

    .table_title {
      padding: 0 18px;
      box-sizing: border-box;
      width: 82px;
      line-height: 34px;
      font-size: 18px;
      background: #eaf2fa;
    }

  }

</style>
